import React from 'react';
import { Input } from '../ui/input';
import { ShieldCheck } from 'lucide-react';
import PhoneInput from '../PhoneInput';

/**
 * Step 0 — Contact information (name, email, phone).
 * Extracted from QualificationModal (2026-07-29 refactor).
 */
export function ContactStep({ form, setForm }) {
  return (
    <div className="space-y-4" data-testid="step-contact">
      <div>
        <h3 className="font-serif text-2xl text-[hsl(var(--primary))]">I tuoi contatti</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Bastano 30 secondi: ti assegniamo l&apos;agente giusto per il tuo profilo.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Input
          placeholder="Nome"
          value={form.first_name}
          onChange={(e) => setForm((f) => ({ ...f, first_name: e.target.value }))}
          className="h-12 text-base"
          data-testid="qf-first-name"
          autoComplete="given-name"
          autoCapitalize="words"
        />
        <Input
          placeholder="Cognome"
          value={form.last_name}
          onChange={(e) => setForm((f) => ({ ...f, last_name: e.target.value }))}
          className="h-12"
          data-testid="qf-last-name"
        />
      </div>
      <Input
        type="email"
        placeholder="Email"
        value={form.email}
        onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
        className="h-12"
        data-testid="qf-email"
      />
      <PhoneInput
        value={form.phone_e164}
        onChange={(p) => setForm((f) => ({
          ...f,
          phone_e164: p.e164,
          phone: p.e164,
          phone_country_code: p.country_code,
        }))}
        required
        placeholder="Numero di telefono *"
        testIdPrefix="qf-phone"
      />
      <p className="text-[11px] text-muted-foreground -mt-1 flex items-center gap-1.5">
        <ShieldCheck className="w-3 h-3 text-[var(--gp-gold)]" />
        Telefono obbligatorio: serve al nostro Senior Associate per ricontattarti su WhatsApp o telefonicamente.
      </p>
    </div>
  );
}
